import { render, staticRenderFns } from "./BaseSelectWithScroll.vue?vue&type=template&id=68b70148"
import script from "./BaseSelectWithScroll.vue?vue&type=script&lang=js"
export * from "./BaseSelectWithScroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports